export const CONFIRM_DEACTIVATE = 'CONFIRM_DEACTIVATE';
export const CONFIRM_DELETE = 'CONFIRM_DELETE';
export const DEACTIVATION_SUCCESS = 'DEACTIVATION_SUCCESS';
export const DELETE_SUCCESS = 'DELETE_SUCCESS';
export const SET_SUCCESS = 'SET_SUCCESS';
export const DUPLICATE_SUCCESS = 'DUPLICATE_SUCCESS';
